import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from '../contexts/ThemeContext';
import InterupsiForm from '../components/forms/InterupsiForm';

const TeacherIjinInterupsiPage = () => {
  const { darkMode } = useContext(ThemeContext);
  const [showForm, setShowForm] = useState(true);

  const handleCloseForm = () => {
    setShowForm(false);
    // Navigate back to teacher home page
    window.history.back();
  };

  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => window.history.back()}>
          ← Kembali
        </BackButton>
        <h1>Ijin Interupsi</h1>
      </PageHeader>
      
      {showForm && (
        <FormContainer>
          <InterupsiForm 
            onClose={handleCloseForm}
            readOnly={false}
          />
        </FormContainer>
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin: 0;
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-dark);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  
  &:hover {
    background-color: var(--background-light);
    border-color: var(--primary);
  }
`;

const FormContainer = styled.div`
  background-color: var(--background);
  border-radius: 16px;
  box-shadow: var(--box-shadow);
  overflow: hidden;
`;

export default TeacherIjinInterupsiPage;